export abstract class Page {
  constructor(protected pageUrl: RegExp | string) {
    if (
      (typeof pageUrl === 'string' && !location.href.endsWith(pageUrl)) ||
      (typeof pageUrl === 'object' && !pageUrl.test(location.href))
    ) {
      return;
    }

    document.addEventListener('DOMContentLoaded', () => this.onLoaded());
  }

  protected abstract onLoaded(): void;
}
